module.exports = __webpack_public_path__ + "static/media/ico-arrow_new.371a3137.svg";